// extracted by mini-css-extract-plugin
export default {"content":"content__2JOy-"};
    if(module.hot) {
      // 1791975638894
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  